import * as React from 'react';

import { DisplayTime } from '@tock/time';
import { OpenClose } from 'components/business/landing-page/Hours';
import { Typography } from 'omakase';

interface Props {
  times: OpenClose[];
  todayLabel?: boolean;
}

type DisplayType = 'CLOSED' | 'ALL_DAY' | 'HOURS';

function getDisplayType(times: OpenClose[]): DisplayType {
  if (times.length === 0) {
    return 'CLOSED';
  } else if (
    times.length === 1 &&
    times[0].openingTime === '04:00' &&
    times[0].closingTime === '03:45'
  ) {
    return 'ALL_DAY';
  } else {
    return 'HOURS';
  }
}

const DisplayHours: React.FunctionComponent<Props> = ({ times, todayLabel }) => {
  const displayType = getDisplayType(times);
  const hourDisplay = (() => {
    switch (displayType) {
      case 'CLOSED':
        return (
          <>
            Closed
            {todayLabel && <span className="ProfileMetadata-hoursTodayPostLabel"> today</span>}
          </>
        );
      case 'ALL_DAY':
        return (
          <Typography component="span" variant="body02">
            All day
          </Typography>
        );
      case 'HOURS':
        return times.map((time, idx) => (
          <div key={idx}>
            <DisplayTime timeValue={time.openingTime} />
            &nbsp;–&nbsp;
            <DisplayTime timeValue={time.closingTime} />
          </div>
        ));
    }
  })();

  return (
    <div className="ProfileMetadata-displayHours">
      {todayLabel && !(displayType === 'CLOSED') && (
        <span className="ProfileMetadata-hoursTodayPreLabel">Today</span>
      )}
      <div>{hourDisplay}</div>
    </div>
  );
};

export default DisplayHours;
